import { defineMessages } from 'react-intl'

const scope = `procurify.components.SavedFilterSelect`

export default defineMessages({
  notificationEditSuccessTitle: {
    id: `${scope}.notificationEditSuccessTitle`,
    defaultMessage: 'Success',
  },
  notificationEditSuccessMessage: {
    id: `${scope}.notificationEditSuccessMessage`,
    defaultMessage: 'Filter saved successfully',
  },
  notificationEditErrorTitle: {
    id: `${scope}.notificationEditErrorTitle`,
    defaultMessage: 'Failed',
  },
  notificationDeleteSuccessMessage: {
    id: `${scope}.notificationDeleteSuccessMessage`,
    defaultMessage: 'Filter deleted successfully',
  },
  editButtonLabel: {
    id: `${scope}.editButtonLabel`,
    defaultMessage: 'Edit filter',
  },
})
